<template>
<div class="modalContents__object10" data-modalContents="thanks02">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-lg-7 col-md-8 col-10 mx-auto row no-gutters">
                <p class="col-12 text-center"><strong>ご契約プランの変更が完了しました。</strong></p>
                <div class="col-md-8 mx-auto">
                    <a href="javascript:void(0);" class="text-center globalModal--btn" @click='reload'>戻る</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapMutations } from "vuex";
import MultiModalMixin from "../mixins/ModalMixin";

export default {
  name: "MypageEditPlanThanks",
  mixins: [MultiModalMixin],
  methods : {
    reload(){
      window.location.reload();
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/mypage_edit_plan_thanks.vue